module.exports = __webpack_public_path__ + "static/media/adaptive_plan.00429a1b.png";